import styled from 'react-emotion';
import { theme, IconButton as BaseIconButton } from '@ublend-npm/aulaui-next';
import AddReaction from '../../../common/Icons/AddReaction';

export const MessageMenuContainer = styled('div')`
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 23px;
  bottom: -43px;
  gap: 9px;
  width: auto;
  height: 44px;
  margin-bottom: 16px;
  transition: opacity 200ms;
  z-index: 150;
  box-sizing: border-box;
  opacity: ${({ isFocusing }) => (isFocusing ? 1 : 0)};
  background-color: ${({ bgColor }) => bgColor};
  border-radius: 6px;
  margin-bottom: 1.5rem;
  box-shadow: #aaa7a76b 0px 0px 4px 0px;
  padding: 4px 8px;
  &:hover {
    opacity: 1;
  }
`;

export const IconButton = styled(BaseIconButton)`
  color: ${theme.color.grey11};
  background-color: transparent;
  display: inline-block;
  transition: opacity 0.2s ease 0s;
  margin: 0;
  box-shadow: none;
  &:hover {
    background-color: ${theme.color.grey2};
  }
`;

export const AddReactionIcon = styled(AddReaction)`
  color: ${theme.color.grey11};
`;
